import { render, staticRenderFns } from "./VideoSuper.vue?vue&type=template&id=d90a300c&scoped=true"
import script from "./VideoSuper.vue?vue&type=script&lang=js"
export * from "./VideoSuper.vue?vue&type=script&lang=js"
import style0 from "./VideoSuper.vue?vue&type=style&index=0&id=d90a300c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90a300c",
  null
  
)

export default component.exports